import { Box, Text, VStack } from '@chakra-ui/react'
import { ProgressCircle } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNewFaxLoadingViewStyle } from '~/pages/Home/Modals/NewFaxModal/componentStyles/NewFaxLoadingView.style'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

interface NewFaxLoadingViewProps {
  progress: number
}

export const NewFaxLoadingView = ({ progress }: NewFaxLoadingViewProps) => {
  const styles = useNewFaxLoadingViewStyle()
  const { t } = useTranslation()
  return (
    <Box as={VStack} css={styles.container}>
      <ProgressCircle.Root
        size={styles.circularProgress.height!.toString()}
        colorPalette={styles.circularProgress.color!.toString()}
        value={progress || undefined}
      >
        <ProgressCircle.Circle>
          <ProgressCircle.Track />
          <ProgressCircle.Range />
        </ProgressCircle.Circle>
      </ProgressCircle.Root>
      <Text {...textStyles[textStyleKeys.H6]}>
        {t('newFaxModal.loadingView.sendingFax')}
      </Text>
    </Box>
  )
}
